/**
 * Generated API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const EvidenceScope = {
    Revision: 'REVISION',
    Product: 'PRODUCT',
    Manufacturer: 'MANUFACTURER'
} as const;
export type EvidenceScope = typeof EvidenceScope[keyof typeof EvidenceScope];

